"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllegroTransformNetWireGenerator = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const TransformNetWire_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformNetWire");
const TransformSchematicDrawing_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformSchematicDrawing");
const TransformSchematic_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformSchematic");
const allegroLayers_1 = require("../../../allegroLayers");
const WIRE_LAYER = allegroLayers_1.AllegroSchLayerMap[sigma_engine_shared_1.DesignModels.SchLayerType.Wire].id;
const BUS_LAYER = allegroLayers_1.AllegroSchLayerMap[sigma_engine_shared_1.DesignModels.SchLayerType.Bus].id;
const JUNCTION_LAYER = allegroLayers_1.AllegroSchLayerMap[sigma_engine_shared_1.DesignModels.SchLayerType.Junction].id;
class AllegroTransformNetWireGenerator {
    constructor() {
        this.runsFor = [
            TransformSchematic_1.TransformSchematic,
        ];
    }
    *generate(schematic, rootContext) {
        const pageNum = schematic.instance.hierarchyEntry.loaded.pageNum;
        const design = rootContext.resolved.designs.find((d) => d.pageNum === pageNum);
        if (design === undefined) {
            return;
        }
        for (const wire of design.wires) {
            const stroke = wire.stroke;
            const drawing = {
                layers: [WIRE_LAYER],
                drawing: {
                    type: 'segment',
                    start: wire.from,
                    end: wire.to,
                    width: stroke.width,
                    ...(stroke.color !== null ? { colorOverride: stroke.color } : {}),
                },
            };
            const strategyMetadata = wire.netName !== null ? { xconNetName: wire.netName } : undefined;
            yield new TransformNetWire_1.TransformNetWire(schematic, wire.from, wire.to, drawing, undefined, undefined, strategyMetadata);
        }
        for (const bus of design.buses) {
            const stroke = bus.stroke;
            yield new TransformSchematicDrawing_1.TransformSchematicDrawing(schematic, {
                layers: [BUS_LAYER],
                drawing: {
                    type: 'segment',
                    start: bus.from,
                    end: bus.to,
                    width: stroke.width,
                    ...(stroke.color !== null ? { colorOverride: stroke.color } : {}),
                },
            });
        }
        for (const junction of design.junctions) {
            yield new TransformSchematicDrawing_1.TransformSchematicDrawing(schematic, {
                layers: [JUNCTION_LAYER],
                drawing: { type: 'junction', position: junction.position, radiusOverride: 0.5 },
            });
        }
    }
}
exports.AllegroTransformNetWireGenerator = AllegroTransformNetWireGenerator;
//# sourceMappingURL=AllegroTransformNetWireGenerator.js.map